import { render, staticRenderFns } from "./tag-icon.vue?vue&type=template&id=09d100ee&"
import script from "./tag-icon.vue?vue&type=script&lang=js&"
export * from "./tag-icon.vue?vue&type=script&lang=js&"
import style0 from "./tag-icon.vue?vue&type=style&index=0&id=09d100ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports